'use client';

import SelectableTile from '@carvana/ds-selectable-tile';
import { useRouter } from 'next/navigation';
import VehicleMakeIcon from '@/common/VehicleMakeIcon';
import tileStyles from '@/new-cars/common/SelectableTile.module.css';
import useTestDriveCenter from '~/hooks/new-cars/useTestDriveCenter';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';

const desktopIconSizes: Record<string, number> = {
  Chrysler: 185,
  Dodge: 185,
  Jeep: 128,
  Ram: 109
};

const mobileIconSizes: Record<string, number> = {
  Chrysler: 117,
  Dodge: 117,
  Jeep: 87,
  Ram: 63
};

type OwnProps = {
  make: string;
};

export default function BrandCard({ make }: OwnProps) {
  const router = useRouter();
  const { session } = useTestDriveCenter();
  const desktopSize = desktopIconSizes[make] ?? 128;
  const mobileSize = mobileIconSizes[make] ?? 87;

  const navigateToMake = () => {
    // Preserve the TDC session through navigation so the make screen stays
    // paired with the cube display. The make screen emits its own selectModel
    // event on mount, so no cube call is needed here.
    const base = `/new/${toLowerKebabCase(make)}`;
    router.push(session ? `${base}?session=${session}` : base);
  };

  return (
    <SelectableTile
      aria-label={make}
      className={tileStyles.tile}
      data-analytics-attributes={JSON.stringify({
        level: 'Brand',
        section: 'Brand',
        text: make
      })}
      data-analytics-id="New Cars"
      data-testid="brand-card"
      onClick={navigateToMake}
      role="link"
      selected={false}
      value={make}
      variant="simple-select"
    >
      <div
        aria-hidden="true"
        className="-mx-xl -my-xl flex h-[92px] items-center justify-center overflow-hidden md:h-[127px]"
      >
        <span className="md:hidden">
          <VehicleMakeIcon make={make} size={mobileSize} />
        </span>
        <span className="hidden md:inline">
          <VehicleMakeIcon make={make} size={desktopSize} />
        </span>
      </div>
    </SelectableTile>
  );
}
